import {injectable} from "inversify";
import {GateTypeEnum} from "@/modules/action-points/enums";
import {GateInterface} from "@/modules/action-points/interfaces";

@injectable()
export default class GateManager {
  constructor(
    private mapping: { [key in GateTypeEnum]: GateInterface },
  ) {
  }

  getGate(type: GateTypeEnum): GateInterface {
    return this.mapping[type];
  }
}
